export const teamList = [
  {
    name: 'Alejandro Cartagena',
    description:
      'Alejandro Cartagena is an artist, photographer and photo book publisher. His work is collected by major museums including the SFMoMA, J. Paul Getty Museum, the MFAH. He is interested in the cultural meaning of photographs. Collector of NFTs. Founding artist of theRAWdao.',
    twitter: 'halecar2',
    img: 'alejandro.png',
  },
  {
    name: 'Cooper Ray',
    description:
      'Cooper Ray is a photographer and avid cyclist from New York City. He is firm believer of web3 and our decentralized future. As an early adopter of artist smart contracts via manifold.xyz for his work, Cooper is an evangelist of creator sovereignty and artist education. Founding artist of the theRAWdao.',
    twitter: '_cooperray_',
    img: 'cooper.png',
  },
  {
    name: 'Tony Herrera',
    description:
      'Immigrant activist turned entrepreneur in the cryptocurrency, blockchain, and NFT space. Founding member of Ether Cards, a dynamic NFT and monetization platform. Founding member of several DAOs dedicated to the Metaverse space including Meebits DAO, Neon DAO and Ready Player DAO.',
    twitter: 'tonyherrera',
    img: 'tony.png',
  },
  {
    name: 'Wim Van Cappellen',
    description:
      'After obtaining a master’s degree in political science, Wim Van Cappellen started his career as a documentary photographer. He won numerous international photo awards and at age 35, he started a photo production agency in Brussels, Belgium. He is an experienced curator and portfolio reviewer.',
    twitter: 'WimVanCappellen',
    img: 'wim.png',
  }
];